import { render, staticRenderFns } from "./officers.vue?vue&type=template&id=e30d80f2&scoped=true"
import script from "./officers.vue?vue&type=script&lang=js"
export * from "./officers.vue?vue&type=script&lang=js"
import style0 from "./officers.vue?vue&type=style&index=0&id=e30d80f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e30d80f2",
  null
  
)

export default component.exports